import type { IconType } from "react-icons/lib";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

interface SidebarButtonProps {
	icon: LucideIcon | IconType;
	label: string;
	isActive?: boolean;
	disabled?: boolean;
	onClick?: () => void;
	onDoubleClick?: () => void;
	onMouseDown?: (e: React.MouseEvent) => void;
}

export const SidebarButton = ({
	icon: Icon,
	label,
	isActive,
	disabled,
	onClick,
	onDoubleClick,
	onMouseDown,
}: SidebarButtonProps) => {
	return (
		<div
			className="group flex cursor-pointer flex-col items-center justify-center gap-y-0.5"
			onClick={onClick}
			onDoubleClick={onDoubleClick}
			onMouseDown={onMouseDown}
		>
			<Button
				variant={isActive ? "default" : "link"}
				className={cn("size-9 p-2 cursor-pointer")}
				disabled={disabled}
			>
				<Icon className="size-5"/>
			</Button>
			<span className={cn("text-[12px]", isActive && "font-bold")}>
				{label}
			</span>
		</div>
	);
};
